<template>
	<v-navigation-drawer
		v-model="detailsDrawer"
		right
		app
		stateless
		fixed
		temporary
		active-class="background-color: 'red'"
		:width="assignDrawerWidth"
		style="z-index: 2000">
		<!--		<profile-settings v-if="getPage === 'settings'"></profile-settings>-->
		<medical-staff-add v-if="getPage === 'medical staff'" />
		<patient-add v-if="getPage === 'patients'" />
		<medical-team-add v-if="getPage === 'medical team'" />
		<assessments-add v-if="getPage === 'assessments'" />
		<monitoring-plans-add v-if="getPage === 'patient details'" />
		<notification-drawer v-if="$route.path === '/dashboard'" />
		<verifier-add v-if="getPage === 'verifier'" />
		<medical-institution-add v-if="getPage === 'organization'" />
		<hospital-add v-if="getPage === 'office'" />
		<organization-mapping-add v-if="getPage === 'organization mapping'" />
		<location-mapping-add v-if="getPage === 'location mapping'" />
		<hospital-admin-add v-if="getPage === 'admins'" />
		<billings-authorization-template-add v-if="getPage === 'billing settings'" />
		<billings-users-authorization-add v-if="getPage === 'user billing settings'" />
		<medical-note-category-add v-if="getPage === 'medical note category'" />
		<add-monitoring-drawer v-if="getPage === 'monitoring'" />
		<add-invocies v-if="getPage === 'invoices'" />
		<add-billing-link-drawer v-if="getPage === 'billings'" />
		<add-license v-if="getPage === 'licenses'" />
		<add-licence-for-patient-drawer v-if="getPage === 'patientLicence'" />
		<assign-patient-to-license-drawer v-if="getPage === 'assignPatientLicense'" />
		<CCMRecordAdd v-if="getPage === 'ccmRecords'" />
		<CCMDiagnosisAdd v-if="getPage === 'ccmDiagnosisAdd'" />
		<CCMConditionAdd v-if="getPage === 'ccmConditionAdd'" />
		<CCMCarePlanAdd v-if="getPage === 'ccmCarePlanAdd'" />
		<CCMVitalEntryAdd v-if="getPage === 'ccmVitalEntryAdd'" />
		<CCMMedicationEventAdd v-if="getPage === 'ccmMedicationEventAdd'" />
		<CCMMedicalNoteAdd v-if="getPage === 'ccmMedicalNoteAdd'" />
		<CCMObservationAdd v-if="getPage === 'ccmObservationAdd'" />
		<CCMAllergyAdd v-if="getPage === 'ccmAllergyAdd'" />
		<CCMAttachmentAdd v-if="getPage === 'ccmAttachmentAdd'" />
		<CCMVaccineAdd v-if="getPage === 'ccmVaccineAdd'" />
		<CCMConsentFormAdd v-if="getPage === 'ccmConsentFormAdd'" />
		<CCMImagingAdd v-if="getPage === 'ccmImagingAdd'" />
		<CCMLabsAdd v-if="getPage === 'ccmLabsAdd'" />
		<MedicalStaffAssign v-if="getPage === 'medicalStaffAssign'" />
		<AddReleaseNote v-if="getPage === 'releaseNotes'" />
		<MedicalNoteCategoryCopyTemplate v-if="getPage === 'copyMedicalNoteCategoryTemplate'" />
		<ScheduleAdd v-if="getPage === 'schedules'" />
		<OrganizationMappingAddPcc v-if="getPage === 'pointclickcare organization mapping'" />
		<LocationMappingAddPcc v-if="getPage === 'pointclickcare location mapping'" />
		<AddInventoryConsumableCatalogDrawer v-if="getPage === 'consumable catalog'" />
		<AddInventoryItemCatalog v-if="getPage === 'item catalog'" />
		<AddInventoryItem v-if="getPage === 'inventory items'" />
		<InventoryConsumableAssign v-if="getPage === 'inventory consumables'" />
		<DeviceTemplateAdd v-if="getPage === 'device template'" />
	</v-navigation-drawer>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import MedicalStaffAdd from '@/views/DrawerDialogs/MedicalStaffAdd.vue';
import PatientAdd from '@/views/DrawerDialogs/PatientAdd.vue';
// import ProfileSettings from '@/views/DrawerDialogs/ProfileSettings.vue';
import MedicalTeamAdd from '@/views/DrawerDialogs/MedicalTeamAdd.vue';
import AssessmentsAdd from '@/views/DrawerDialogs/AssessmentsAdd.vue';
import MonitoringPlansAdd from '@/views/DrawerDialogs/MonitoringPlansAdd.vue';
import NotificationDrawer from '@/views/DrawerDialogs/NotificationDrawer.vue';
import VerifierAdd from '@/views/DrawerDialogs/VerifierAdd.vue';
import MedicalInstitutionAdd from '@/views/DrawerDialogs/MedicalInstitutionAdd.vue';
import HospitalAdd from '@/views/DrawerDialogs/HospitalAdd';
import OrganizationMappingAdd from '@/views/DrawerDialogs/OrganizationMappingAdd';
import LocationMappingAdd from '@/views/DrawerDialogs/LocationMappingAdd';
import HospitalAdminAdd from '@/views/DrawerDialogs/HospitalAdminAdd';
import BillingsAuthorizationTemplateAdd from '@/views/DrawerDialogs/AddBillingSettingsTemplate.vue';
import BillingsUsersAuthorizationAdd from '@/views/DrawerDialogs/AddUserBillingSettings.vue';
import MedicalNoteCategoryAdd from '@/views/DrawerDialogs/MedicalNoteCategoryAdd';
import AddMonitoringDrawer from '@/views/DrawerDialogs/AddMonitoringDrawer';
import AddInvocies from '@/views/DrawerDialogs/AddInvocies.vue';
import AddBillingLinkDrawer from '@/views/DrawerDialogs/AddBillingLinkDrawer.vue';
import AddLicense from '@/views/DrawerDialogs/AddLicense.vue';
import addLicenceForPatientDrawer from '@/views/DrawerDialogs/AddLicenceForPatientDrawer.vue';
import assignPatientToLicenseDrawer from '@/views/DrawerDialogs/AssignPatientToLicenseDrawer.vue';
import CCMRecordAdd from '../DrawerDialogs/CCMRecordAdd.vue';
import CCMDiagnosisAdd from '../DrawerDialogs/CCMDiagnosisAdd.vue';
import CCMConditionAdd from '../DrawerDialogs/CCMConditionAdd.vue';
import CCMCarePlanAdd from '../DrawerDialogs/CCMCarePlanAdd.vue';
import CCMVitalEntryAdd from '../DrawerDialogs/CCMVitalEntryAdd.vue';
import CCMMedicationEventAdd from '../DrawerDialogs/CCMMedicationEventAdd.vue';
import CCMMedicalNoteAdd from '../DrawerDialogs/CCMMedicalNoteAdd.vue';
import CCMObservationAdd from '../DrawerDialogs/CCMObservationAdd.vue';
import CCMAllergyAdd from '../DrawerDialogs/CCMAllergyAdd.vue';
import CCMAttachmentAdd from '../DrawerDialogs/CCMAttachmentAdd.vue';
import CCMVaccineAdd from '../DrawerDialogs/CCMVaccineAdd.vue';
import CCMConsentFormAdd from '../DrawerDialogs/CCMConsentFormAdd.vue';
import CCMImagingAdd from '../DrawerDialogs/CCMImagingAdd.vue';
import CCMLabsAdd from '../DrawerDialogs/CCMLabsAdd.vue';
import AddReleaseNote from '../DrawerDialogs/AddReleaseNote.vue';
import MedicalStaffAssign from '../DrawerDialogs/MedicalStaffAssign.vue';
import MedicalNoteCategoryCopyTemplate from '../DrawerDialogs/MedicalNoteCategoryCopyTemplate.vue';
import ScheduleAdd from '../DrawerDialogs/ScheduleAdd.vue';
import OrganizationMappingAddPcc from '@/views/DrawerDialogs/OrganizationMappingAddPcc.vue';
import LocationMappingAddPcc from '../DrawerDialogs/LocationMappingAddPcc.vue';
import AddInventoryConsumableCatalogDrawer from '../DrawerDialogs/AddInventoryConsumableCatalogDrawer.vue';
import AddInventoryItemCatalog from '../DrawerDialogs/AddInventoryItemCatalogDrawer.vue';
import AddInventoryItem from '../DrawerDialogs/AddInventoryItemDrawer.vue';
import InventoryConsumableAssign from '../DrawerDialogs/AddInventoryConsumable.vue';
import DeviceTemplateAdd from '../DrawerDialogs/DeviceTemplateAdd.vue';

export default {
	components: {
		MedicalNoteCategoryAdd,
		BillingsUsersAuthorizationAdd,
		AddInvocies,
		AddBillingLinkDrawer,
		BillingsAuthorizationTemplateAdd,
		// AddNoteDrawer,
		AssessmentsAdd,
		AddMonitoringDrawer,
		MedicalStaffAdd,
		PatientAdd,
		// ProfileSettings,
		MedicalTeamAdd,
		MonitoringPlansAdd,
		NotificationDrawer,
		VerifierAdd,
		MedicalInstitutionAdd,
		HospitalAdd,
		HospitalAdminAdd,
		AddLicense,
		addLicenceForPatientDrawer,
		assignPatientToLicenseDrawer,
		CCMRecordAdd,
		CCMDiagnosisAdd,
		CCMConditionAdd,
		CCMCarePlanAdd,
		CCMMedicationEventAdd,
		CCMMedicalNoteAdd,
		CCMVitalEntryAdd,
		CCMObservationAdd,
		CCMAllergyAdd,
		CCMAttachmentAdd,
		CCMVaccineAdd,
		CCMConsentFormAdd,
		CCMImagingAdd,
		CCMLabsAdd,
		OrganizationMappingAdd,
		OrganizationMappingAddPcc,
		LocationMappingAdd,
		AddReleaseNote,
		MedicalStaffAssign,
		MedicalNoteCategoryCopyTemplate,
		ScheduleAdd,
		LocationMappingAddPcc,
		AddInventoryConsumableCatalogDrawer,
		AddInventoryItemCatalog,
		AddInventoryItem,
		InventoryConsumableAssign,
		DeviceTemplateAdd,
	},
	data () {
		return {
			// activePatientDetailsDrawer: '',
			items: [
				{ title: 'Home', icon: 'mdi-view-dashboard' },
				{ title: 'About', icon: 'mdi-forum' },
			],
		};
	},
	computed: {
		...mapState(['barColor', 'barImage', 'webrtcErrors', 'pageSize', 'assignDrawerWidth']),
		...mapGetters({
			pageWidth: 'pageHeight',
			getPage: 'getPage',
		}),
		detailsDrawer: {
			get () {
				// this.selectPatientDrawer(this.$store?.state.activePatientsDrawer);
				return this.$store.state.detailsDrawer;
			},
			set (val) {
				this.$store.commit('SET_DETAILS_DRAWER', val);
			},
		},
	},
	watch: {
		getPage (val) {},
	},
	// methods: {
	//   selectPatientDrawer (dat) {
	//     this.activePatientDetailsDrawer = dat;
	//   },
	// },
};
</script>
